import { render, staticRenderFns } from "./RecursiceAiFactors.vue?vue&type=template&id=28d1576a&scoped=true&"
import script from "./RecursiceAiFactors.vue?vue&type=script&lang=ts&"
export * from "./RecursiceAiFactors.vue?vue&type=script&lang=ts&"
import style0 from "./RecursiceAiFactors.vue?vue&type=style&index=0&id=28d1576a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d1576a",
  null
  
)

export default component.exports